<script>
  import { mapState } from 'vuex'
  import { navigation } from '../navigation'
  import Navigation from './navigation/Navigation'

  export default {
    name: 'default-layout',

    components: {
      Navigation
    },

    computed: {
      ...mapState('navigation', {
        isCollapsed: state => state.isCollapsed
      })
    },

    data () {
      return {
        items: navigation
      }
    }
  }
</script>

<template>
  <div class="layout" :class="{'menu-opened': !isCollapsed }">
    <navigation :items="items" :show-children="true">
      <template slot="logo">
        <img src="/img/logo.png" alt="Hive">
      </template>
    </navigation>
    <router-view/>
  </div>
</template>

<style src="./DefaultLayout.scss" lang="scss" scoped></style>
